import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import ConservatoryImage from "../ConservatoryImage/ConservatoryImage";
import SvgComponent from "../SvgComponent/SvgComponent";

import { usePreviewData } from "./usePreviewData";

import {
  PreviewContainer,
  FrameName,
  UterumSummary,
  SquareMeter,
  SquareMeterDetails,
  PriceLabel,
  OrdinaryPriceLabel,
  DiscountedPrice,
  FrameSeason,
  NameAndSeason,
  SeasonIcon,
  DiscountList,
} from "./style";

const Preview = ({ renderDimensions = false, dataId }) => {
  const Uterum = useSelector((state) => state.Uterum);

  const {
    alias,
    frameType,
    frameTypeTitle,
    seasonTitle,
    seasonIconName,
    squareMeter,
    frameWidth,
    frameDepth,
    formattedPrice,
    formattedOrdinaryPrice,
    formattedProductDiscount,
    discounts,
    hasProductDiscounts,
  } = usePreviewData();

  return (
    <PreviewContainer data-id={dataId} className="Preview">
      <ConservatoryImage
        // frameType and smaller are used to determine special style properties for FIRAXL, LYCKA, FIRAVINKEL and Uterum.ground
        frameType={frameType}
        smaller={Uterum.Ground ? true : false}
      />
      <NameAndSeason>
        <FrameName data-id={`${dataId}__FrameName`}>{frameTypeTitle}</FrameName>
        <FrameSeason data-id={`${dataId}__FrameSeason`}>
          <SeasonIcon>
            <SvgComponent name={seasonIconName} />
          </SeasonIcon>
          <span>{seasonTitle}</span>
        </FrameSeason>
      </NameAndSeason>
      <UterumSummary>
        <div>
          <SquareMeter>
            {squareMeter} m<sup>2</sup>
            {renderDimensions && (
              <SquareMeterDetails>
                ({frameWidth}x{frameDepth})
              </SquareMeterDetails>
            )}
          </SquareMeter>
          <PriceLabel>
            {!hasProductDiscounts && discounts.length < 1 ? (
              <span>{formattedOrdinaryPrice}</span>
            ) : (
              <>
                <DiscountedPrice>{formattedPrice}</DiscountedPrice>
                <OrdinaryPriceLabel>{formattedOrdinaryPrice}</OrdinaryPriceLabel>
              </>
            )}
          </PriceLabel>
        </div>
        {
          discounts.length > 0 ? (
            <DiscountList>
              {discounts.map(discount => {
                return <li key={discount.PromotionName}>{discount.PromotionName}: &minus; {discount.FormattedDiscount}</li>;
              })}
              {hasProductDiscounts ? <li>{alias.bfcDiscount} &minus; {formattedProductDiscount}</li> : ''}
            </DiscountList>
          ) : ''
        }
      </UterumSummary>
    </PreviewContainer>
  );
};

Preview.propTypes = {
  renderDimensions: PropTypes.bool,
  dataId: PropTypes.string,
};

export default Preview;
